
import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator'
import { Observer } from 'mobx-vue'

@Observer
@Component({
  name: 'PopLayout',
  components: {}
})
export default class PopLayout extends Vue {
  @Prop({ default: false }) escToClose: boolean

  innerVisible: boolean = false

  open() {
    if (this.innerVisible === true) return

    this.innerVisible = true
  }

  hide() {
    if (this.innerVisible === false) return

    this.innerVisible = false
  }

  onVisible(val: boolean) {
    if (!val) this.$emit('close')
  }

  @Emit('closed')
  onClosed() {}

  @Emit('opened')
  onOpened() {}

  created() {}
  mounted() {}
  updated() {}
  destroyed() {}
}
